import { UserOutlined } from "@ant-design/icons";
import { Checkbox, DatePicker, Form, Input, Modal, Switch } from "antd";
import { SingleImageUpload } from "components/SingleImageUpload";
import React from "react";
import { api } from "services/api";
import Swal from "sweetalert2";
import { IAddUsers } from "types";
import { getBase64Img } from "utils";

export const AddUserModal: React.FC<IAddUsers> = ({ ...props }) => {
	const {
		form,
		isOpen,
		setCurrentImgURL,
		setIsOpen,
		// userStatus,
		userRoles,
		currentImgURL,
		setUserStatus,
		userStatus,
		setUserRoles,
		setBirthDate,
		birthdate,
		onCreated
	} = props;

	const handleRegister = (values: any) => {
		api
			.post("/manager/users", values)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					
					if(onCreated) {
						onCreated(result.data);
					}
					
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
						form.resetFields();
						setCurrentImgURL("");
						setUserRoles([]);
						setUserStatus(false);
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	return (
		<Modal
			title={<p style={{ margin: 0 }}>Cadastrar novo usuário</p>}
			open={isOpen}
			maskClosable={false}
			okText="Cadastrar usuário"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values) => {
						const allValues = {
							...values,
							avatar_image: currentImgURL,
							birth_date: `${birthdate}`,
							type_auth: "email",
							password_confirmation: form.getFieldValue("password"),
							roles: userRoles,
						};
						handleRegister(allValues);
					})
					.catch((info) => {
						console.log("Validate Failed:", info);
					});
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				setCurrentImgURL("");
				setUserRoles([]);
				form.resetFields();
				setUserStatus(false);
			}}
			width={700}
		>
			<Form form={form} name="new-user" autoComplete="off" layout="vertical">
				<div className="users-modal">
					<div
						className="users-modal__login-info row row-cols-1 row-cols-md-2"
					>
						<SingleImageUpload showImgURL={currentImgURL?? undefined} onChange={setCurrentImgURL}/>
						
						<div className="mt-1">
							<Form.Item
								label="Nome"
								name="name"
								rules={[
									{
										required: true,
										message: "Nome necessário",
									},
								]}
							>
								<Input placeholder="Nome" />
							</Form.Item>
							<Form.Item
								label="Email"
								name="email"
								rules={[
									{
										required: true,
										message: "E-mail necessário",
									},
								]}
							>
								<Input placeholder="E-mail" />
							</Form.Item>
							<Form.Item
								label="Data de nascimento"
								name={"birth_date"}
								rules={[
									{
										required: true,
										message: "Data de nascimento necessária",
									},
								]}
							>
								<DatePicker
									format={"DD/MM/YYYY"}
									placeholder={"Data de Nascimento"}
									onChange={(_, date) => setBirthDate && setBirthDate(date)}
									style={{width:'100%'}}
								/>
							</Form.Item>
						</div>
					</div>
					<div className="row row-cols-1 row-cols-md-2">
						<Form.Item
							label="Usuário"
							name="username"
							rules={[
								{
									required: true,
									message: "Username necessário",
								},
							]}
						>
							<Input placeholder="Username" />
						</Form.Item>
						<Form.Item
							label="Senha"
							name="password"
							rules={[{ required: true, message: "Senha necessária" }]}
						>
							<Input.Password placeholder="Senha" />
						</Form.Item>
					</div>
					<div className="row row-cols-1 row-cols-md-2 mt-2 mt-md-0">
						<div className="users-modal__login-info__user-types">
							<p className="text-secondary fw-medium  mb-0">Perfil do usuário</p>
							<Checkbox.Group
								style={{ width: "100%" }}
								value={userRoles}
								onChange={(e) => setUserRoles(e)}
							>
								<div className="d-flex">
									<Checkbox value="aluno">Aluno</Checkbox>

									<Checkbox value="professor">Professor</Checkbox>

									<Checkbox value="gestor">Gestor</Checkbox>
								</div>
							</Checkbox.Group>
						</div>
						<div className="mt-2 mt-md-0">
							<div className="users-modal__status">
								<p className="mb-0">Status do usuário</p>
								<Switch checked={userStatus} onClick={(e) => setUserStatus(e)} />
							</div>
						</div>
					</div>
				</div>
			</Form>
		</Modal>
	);
};
